export const planBook = {
  planBookType: [{
    label: '个人计划书', value: '01'
  }, {
    label: '家庭计划书', value: '02'
  }, {
    label: '高端医疗', value: '03'
  }]
}
export default {
  planBook
}



// WEBPACK FOOTER //
// ./src/data/planBook.js